import { freddyTheme } from '@coolblue-development/freddy';
export const getHighlightDotStyles = ({ coordinates, }) => ({
    position: 'absolute',
    top: `calc(${coordinates.y * 100}%)`,
    left: `calc(${coordinates.x * 100}%)`,
    transform: 'translate(-50%, -50%)',
});
export const getDotStyles = {
    width: '24px',
    height: '24px',
    cursor: 'pointer',
    boxSizing: 'border-box',
    borderRadius: '50%',
    border: `${freddyTheme.borderWidth[25]} solid ${freddyTheme.color.border.tertiary}`,
    zIndex: 0,
    '&:hover': {
        backgroundColor: freddyTheme.color.background.base,
        opacity: 1,
        '&::after': {
            backgroundColor: freddyTheme.color.icon.base,
        },
    },
    '&::after': {
        content: '""',
        zIndex: 1,
        width: '8px',
        height: '8px',
        backgroundColor: freddyTheme.color.icon.inverse,
        borderRadius: '50%',
    },
};
export const getPulseDotStyles = {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    background: freddyTheme.color.icon.base,
    cursor: 'pointer',
    outline: `${freddyTheme.borderWidth[25]} solid ${freddyTheme.color.border.base}`,
    '&::before, &::after': {
        content: '""',
        position: 'absolute',
        width: '8px',
        height: '8px',
        borderRadius: '50%',
        backgroundColor: freddyTheme.color.icon.base,
        transformOrigin: 'center center',
        animation: 'pulse-me 1.5s linear infinite',
    },
    '&::after': {
        animationDelay: '1s',
    },
    '@keyframes pulse-me': {
        '0%': {
            transform: 'scale(0.5)',
            opacity: '0',
        },
        '50%': {
            opacity: '0.6',
        },
        '70%': {
            opacity: '0.3',
        },
        '100%': {
            transform: 'scale(4)',
            opacity: '0',
        },
    },
    '@-webkit-keyframes pulse': {
        '50%': {
            opacity: '0.6',
        },
    },
};
//# sourceMappingURL=Inspirational.styled.js.map